export default {
  SET_movements(state, payload) {
    state.movements = payload
  },

  SET_movementTypes(state, payload) {
    state.movement_types = payload
  },
}
